const ORIGIN = '/userportal'
// const ORIGIN = ""

const API = {
  // 客户端里的 邀请、切换组织、创建加入组织 页面使用v3接口
  GET_TOKEN: ORIGIN + '/get_token',
  CREATE_TEAM: ORIGIN + '/api/client/create_team',
  JOIN_ORG: ORIGIN + '/api/register/join_org',
  GET_LOGIN_KEY: ORIGIN + '/get_login_key',
  GET_TEAM_LIST: ORIGIN + '/get_other_team_list',
  INVITE: ORIGIN + '/email_invite',

  GET_JWT_TOKEN_V4: '/v4/security/identify.get.jwt.token',
  GET_SHARE_LINK: '/v4/share/link',
  GET_SHARE_QRCODE: '/v4/share/qrcode',
}

export const API_V5 = {
  GET_LOGIN_STATUS: '/api/v5/auth/status',
  POST_EMAIL_CODE: '/api/v5/auth/email.code.send',
  POST_EMAIL_CODE_CHECK: '/api/v5/auth/email.code.check',

  POST_USER_ADD: '/api/v5/auth/user.add',
  POST_TEAM_CREATE: '/api/v5/auth/team.create',
  POST_TEAM_JOIN: '/api/v5/auth/team.join',

  POST_EMAIL_INVITE: '/api/v5/auth/email.invite.send',
  GET_TEAM_LIST: '/api/v5/auth/team.list',
  POST_TEAM_OPEN: '/api/v5/auth/team.open',
  POST_TEAM_SWITCH: '/api/v5/auth/team.switch',
  GET_INVITE_LIST: '/api/v5/auth/email.invite.list',
  POST_INVITE_HANDLE: '/api/v5/auth/email.invite.handle',
  POST_GET_LOGIN_KEY: '/api/v5/auth/login.key.get',

  // password
  POST_AUTH_LOGIN: '/api/v5/auth/login',
  POST_MFA_CHECK: '/api/v5/auth/mfa.check',
  POST_EMAIL_SEND: '/api/v5/auth/email.send',
  POST_EMAIL_CHECK: '/api/v5/auth/email.check',
  POST_PASSWORD_SET: '/api/v5/auth/password.set',
  POST_REGISTER_EMAIL_CHECK: '/api/v5/auth/user.register.check',
  POST_CREATE_USER: '/api/v5/auth/user.create',
  POST_EMAIL_VERIFY: '/api/v5/auth/email.verify',
  POST_EMAIL_REGISTER_SEND: '/api/v5/auth/email.code.send',
}

export default API
